import api from './client';

export const getPaymentSettings = () =>
  api.get('/admin/payment-settings').then(r => r.data);

export const updatePaymentSettings = (data) =>
  api.put('/admin/payment-settings', data).then(r => r.data);
